import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { RESET_STATE } from '../../store/actions';
import { checkForDomain } from '../../utils';

export const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return () => {
    dispatch({ type: RESET_STATE });

    const domain = checkForDomain();

    Cookies.remove('X-ADMIN-JWT', { path: '/' });
    Cookies.remove('X-ADMIN-JWT', { domain });
    Cookies.remove('X-ADMIN-ID', { path: '/' });
    Cookies.remove('X-ADMIN-ID', { domain });
    Cookies.remove('name', { path: '/' });
    Cookies.remove('user_id', { path: '/' });
    Cookies.remove('startup_id', { path: '/' });
    Cookies.remove('email', { path: '/' });
    Cookies.remove('is_profile_complete', { path: '/' });
    Cookies.remove('step', { path: '/' });
    Cookies.remove('permissions', { path: '/' });
    Cookies.remove('ur', { path: '/' });
    Cookies.remove('search_startups', { path: '/' });
    Cookies.remove('search_backrr_startups', { path: '/' });
    Cookies.remove('backrr_startups_query', { path: '/' });
    Cookies.remove('backrr_startups_status', { path: '/' });

    const cookies = document.cookie.split(';');
    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    });

    navigate('/login');
  };
};
